import XHTTP from "services/api/xhttp";

class AuthenticationApi {
  static END_POINTS = {
    getAuthFromCredentials: "/auth/login/",
    refreshAuthentication: "/auth/request_access_token/",
    ssoAuth: "/sso/auth",
  };

  static refreshAuthentication(refresh_token) {
    return XHTTP(AuthenticationApi.END_POINTS.refreshAuthentication, {
      method: "get",
      headers: {
        "X-Refresh-Token": refresh_token.token,
      },
    });
  }

  static resetPassword(userId, token, newPassword) {
    // return XHTTP(AuthenticationApi.END_POINTS.resetPassword, {
    //   method: "post",
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   body: JSON.stringify({
    //     token: token,
    //     id: userId,
    //     password: newPassword
    //   })
    // });
  }

  static getAuthFromCredentials(credentials) {
    return XHTTP(AuthenticationApi.END_POINTS.getAuthFromCredentials, {
      method: "post",
      body: JSON.stringify(credentials),
      noAuth: true,
    });
  }

  static ssoAuth(code) {
    return XHTTP(AuthenticationApi.END_POINTS.ssoAuth, {
      method: "post",
      noAuth: true,
      body: JSON.stringify({
        code,
      }),
    });
  }
}

export default AuthenticationApi;
